import { render, staticRenderFns } from "./table-data.vue?vue&type=template&id=af00aac2&"
import script from "./table-data.vue?vue&type=script&lang=js&"
export * from "./table-data.vue?vue&type=script&lang=js&"
import style0 from "./table-data.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VDataTable,VFlex,VLayout})
